import { markNotificationAsRead } from "@lib/redux/slices/notifications";
import { Notification } from "@lib/types/Notification";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTypedDispatch } from "@lib/redux";
import { getNotificationProps } from "@lib/helpers/notificationHelper";
import { AuthRoles } from "@lib/types";
import { MessageFormatElement } from "react-intl";

type Props = {
  initialNotification?: Notification;
  role: AuthRoles;
  messages: Record<string, string> | Record<string, MessageFormatElement[]>;
};

export const useNotification = (props: Props) => {
  const { initialNotification, role, messages } = props;
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  const handleClick = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    _notification?: Notification,
  ) => {
    // event.preventDefault();
    // event.stopPropagation();
    const notification = _notification || initialNotification;

    dispatch(markNotificationAsRead(notification?.id))
      .unwrap()
      .catch((error) => {
        toast.error(error);
      });

    const notificationProps = getNotificationProps({
      notification,
      role,
      messages,
    });

    navigate(notificationProps.url, {
      state: {
        notificationState: notification,
      },
    });
  };

  return { handleClick };
};
